@if (form) {
    <div class="px-2">
        <div class="section-header">{{ 'layout.config.language' | translate }}</div>
        <div class="flex">
            <app-radio-input
                [form]="form"
                id="language"
                [staticOptions]="languages"
                valueKey="code"
            >
                <ng-template #label let-data>
                    <img
                        src="../../../../../assets/flags/flag_placeholder.png"
                        [class]="'flag flag-' + data.code.toLowerCase() + ' flag-size'"
                    />
                    {{ data.name }}
                </ng-template>
            </app-radio-input>
        </div>

        <hr class="mt-4"/>

        <div class="section-header">{{ 'layout.config.colorScheme' | translate }}</div>
        <div class="flex">
            <app-radio-input
                [form]="form"
                id="colorScheme"
                [staticOptions]="colorSchemas"
                prefix="layout.config."
            ></app-radio-input>
        </div>

        <!--        temporary removed - must be completed-->
        <!--            <div class="section-header">{{ 'layout.config.inputStyle' | translate }}</div>-->
        <!--            <div class="flex">-->
        <!--                <div class="field-radiobutton mr-6">-->
        <!--                    <p-radioButton-->
        <!--                        id="outlined_input"-->
        <!--                        name="inputStyle"-->
        <!--                        value="outlined"-->
        <!--                        [(ngModel)]="inputStyle"-->
        <!--                        inputId="outlined_input"-->
        <!--                    ></p-radioButton>-->
        <!--                    <label for="outlined_input">{{ 'layout.config.outlined' | translate }}</label>-->
        <!--                </div>-->
        <!--                <div class="field-radiobutton">-->
        <!--                    <p-radioButton-->
        <!--                        id="filled_input"-->
        <!--                        name="inputStyle"-->
        <!--                        value="filled"-->
        <!--                        [(ngModel)]="inputStyle"-->
        <!--                        inputId="filled_input"-->
        <!--                    ></p-radioButton>-->
        <!--                    <label for="filled_input">{{ 'layout.config.filled' | translate }}</label>-->
        <!--                </div>-->
        <!--            </div>-->

        <div class="section-header">{{ 'layout.config.menuType' | translate }}</div>
        <div class="flex">
            <app-radio-input
                [form]="form"
                id="menuType"
                [staticOptions]="menuTypes"
                [columns]="3"
                prefix="layout.config."
            ></app-radio-input>
        </div>

        <div class="grid mb-3">
            <div class="col-6">
                <div class="section-header">{{ 'layout.config.menuTheme' | translate }}</div>
                @if (form.value.colorScheme === 'light') {
                    <div class="flex flex-wrap gap-3">
                        @for (theme of menuThemes; track theme.name) {
                            <a
                                role="button"
                                type="button"
                                class="w-2rem h-2rem cursor-pointer hover:shadow-4 border-round transition-duration-150 checkmark"
                                pRipple
                                [ngStyle]="{ 'background-color': theme.color }"
                                [pTooltip]="theme.name"
                                [ngClass]="{ 'checkmark-white': theme.logoColor === 'light', 'checkmark-black': theme.logoColor === 'dark' }"
                                (click)="changeMenuTheme(theme.name)"
                            >
                                @if (theme.name === form.value.menuTheme) {
                                    <i class="pi pi-check"></i>
                                }
                            </a>
                        }
                    </div>
                }
            </div>

            <div class="col-6">
                <div class="section-header">{{ 'layout.config.componentThemes' | translate }}</div>
                <div class="flex flex-wrap gap-3">
                    @for (theme of componentThemes; track theme.name) {
                        <a
                            role="button"
                            type="button"
                            class="w-2rem h-2rem cursor-pointer hover:shadow-4 border-round transition-duration-150 checkmark"
                            pRipple
                            [ngStyle]="{ 'background-color': theme.color }"
                            [pTooltip]="theme.name"
                            (click)="changeComponentTheme(theme.name)"
                        >
                            @if (theme.name === form.value.componentTheme) {
                                <i class="pi pi-check"></i>
                            }
                        </a>
                    }
                </div>
            </div>

            <div class="col-6">
                <div class="section-header">{{ 'layout.config.surface' | translate }}</div>
                <div class="flex flex-wrap gap-3">
                    @for (surface of surfaces; track surface.name) {
                        <a
                            role="button"
                            type="button"
                            class="w-2rem h-2rem cursor-pointer hover:shadow-4 border-round transition-duration-150 checkmark"
                            pRipple
                            [ngStyle]="{ 'background-color': surface.color }"
                            [pTooltip]="surface.name"
                            (click)="changeComponentSurface(surface.name)"
                        >
                            @if (surface.name === form.value.surface) {
                                <i class="pi pi-check"></i>
                            }
                        </a>
                    }
                </div>
            </div>
        </div>

        <div class="section-header">{{ 'layout.config.scale' | translate }}</div>
        <div class="flex align-items-center gap-small mb-5">
            <app-button
                icon="pi-minus"
                [rounded]="true"
                [text]="true"
                [disabled]="form.value.scale === scales[0]"
                styleClass="scale-icon-size"
                (clickEvent)="decrementScale()"
            ></app-button>
            <div class="flex gap-2 align-items-center">
                @for (s of scales; track $index) {
                    <i
                        class="pi pi-circle-fill text-300 text-2xl"
                        [ngClass]="{ 'text-primary-500 text-4xl': s === form.value.scale }"
                    ></i>
                }
            </div>
            <app-button
                icon="pi-plus"
                [rounded]="true"
                [text]="true"
                [disabled]="form.value.scale === scales[scales.length - 1]"
                styleClass="scale-icon-size"
                (clickEvent)="incrementScale()"
            ></app-button>
        </div>
    </div>
}

<div #dialogFooter class="p-dialog-footer"></div>
